document.addEventListener('DOMContentLoaded', () => {
  const grid = document.querySelector('.main-blog__grid');
  if (!grid) return;

  const progress = document.querySelector('.main-blog__progress');
  const progressBar = progress?.querySelector('.main-blog__progress-bar');
  const progressText = progress?.querySelector('.main-blog__progress-text');
  let isLoading = false;

  function updateProgress() {
    if (!progress) return;
    const viewed = grid.querySelectorAll('.main-blog__card').length;
    const total = parseInt(progress.dataset.total);
    const template = progress.dataset.textTemplate;

    progressText.textContent =
      template.replace('__VIEWED__', viewed).replace('__TOTAL__', total);
    progressBar.style.setProperty('--progress', `${(viewed / total) * 100}%`);
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.main-blog__load-more-btn');
    if (!btn || isLoading) return;

    const nextUrl = btn.dataset.nextUrl;
    if (!nextUrl) return;

    const textEl = btn.querySelector('.main-blog__load-more-text');
    const spinnerEl = btn.querySelector('.main-blog__load-more-spinner');

    isLoading = true;
    btn.setAttribute('aria-busy', 'true');
    textEl.hidden = true;
    spinnerEl.hidden = false;

    try {
      const res = await fetch(nextUrl);
      if (!res.ok) throw new Error(res.statusText);

      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newCards = doc.querySelectorAll('.main-blog__card');
      newCards.forEach((card) => grid.appendChild(card));

      // Re-observe for scroll animations
      if (window.Theme?.animations?.observe) {
        newCards.forEach((card) => window.Theme.animations.observe(card));
      }

      updateProgress();

      const newBtn = doc.querySelector('.main-blog__load-more-btn');
      if (newBtn && newBtn.dataset.nextUrl) {
        btn.dataset.nextUrl = newBtn.dataset.nextUrl;
        textEl.hidden = false;
        spinnerEl.hidden = true;
        btn.removeAttribute('aria-busy');
      } else {
        btn.closest('.main-blog__load-more').remove();
      }
    } catch (err) {
      console.error('Load more failed:', err);
      textEl.hidden = false;
      spinnerEl.hidden = true;
      btn.removeAttribute('aria-busy');
    }

    isLoading = false;
  });
});
